import Parse from "parse";
import config from "../config";

const parseSdk = {
  parseApplicationID: config.parse.appId,
  parseJavascriptKey: config.parse.jsKey,
  parseServerURL: config.parse.serverUrl,

  init: function () {
    Parse.initialize(this.parseApplicationID, this.parseJavascriptKey);
    Parse.serverURL = this.parseServerURL;
  },

  loadConfig: () =>
    Parse.Config.get(),

  checkLogin: () => {
    const { search, hash, pathname } = window.location;
    const urlParams = new URLSearchParams(search);
    const userEmailParam = urlParams?.has("user") ? urlParams.get("user") : "";

    if (Parse.User.current()) {
      if (!userEmailParam) return true;

      // remove query string vars from visual url
      window.history.replaceState(
        { page: pathname },
        document.title,
        pathname + hash,
      );

      return true;
    } else {
      if (hash) {
        urlParams.append("redirect", hash);
      }

      const loginUrl = urlParams.toString()
        ? `/login.html?${urlParams.toString()}`
        : "/login.html";

      window.location = loginUrl;

      return false;
    }
  },

  checkHealth: () => Parse.getServerHealth(),
};

export default parseSdk;
